export default "__VITE_ASSET__B54MZMhL__"